<template>
  <mfe-connect :service-url="serviceUrl"
               :application-name="applicationName"
               @ready="mountApp">
    <div ref="entryPoint" />
  </mfe-connect>
</template>

<script>
import MfeConnect from "./../mfe_connect";

export default {
  name: "SavingsRwn",
  components: {
    MfeConnect,
  },

  props: {
    offeringGlobalId: { type: String, required: true },
  },

  data() {
    return {
      serviceUrl: PSData.savings.uiUrl,
      applicationName: "rwn",
    };
  },
  computed: {
    propsForSavingsRwnApp() {
      return {
        offeringGlobalId: this.offeringGlobalId,
      };
    },
  },

  methods: {
    mountApp() {
      SavingsRwnApp.mount({
        element: this.$refs.entryPoint,
        ...this.propsForSavingsRwnApp,
      });
    },
  },
};
</script>
